
import { Component, Watch, Mixins } from 'vue-property-decorator';
import WhiteLabelMixin from '@/features/common/mixins/whiteLabelMixin';
import PrintMixin from './mixin';

@Component
export default class PrintReturnCard extends Mixins(WhiteLabelMixin, PrintMixin) {
  get isLabelFree(): boolean {
    return !!this.shipmentPrintData?.isLabelFree;
  }

  get isLabelFreeBoxFree(): boolean {
    return !!this.shipmentPrintData?.isBoxFree;
  }

  @Watch('isInitialDataLoaded', { immediate: true })
  private loadAndStoreInProgressData(newValue: number) {
    if (!newValue) return;
    this.printReturnLabel();
  }

  private printReturnLabel() {
    this.getPrintLabelSrcAndPrint();
  }
}
